import { SubDomain } from "../../SubDomain";
import VehicleData from "./VehicleData.js";
import VehicleDataMap from "./VehicleDataMap.js";

export default class VehicleDataDomain extends SubDomain {

  constructor(domain, storage) {
    super(domain, VehicleData.MODEL_NAME);
    this._storage = storage;
  }

  list() {
    return this._storage ? this._storage.list : [];
  }

  findById(objId) {
    var object = this._storage ? this._storage.map[objId] : null;
    return new VehicleData(this.domain, object);
  }

  findByAll() {
    var objects = this.list();
    var map = new VehicleDataMap(this.domain);
    for (var i = 0; i < objects.length; i++) {
      map.add(new VehicleData(this.domain, objects[i]));
    }
    return map;
  }
}
